/* eslint-disable global-require */
import mapValues from 'lodash/mapValues';

import EffectChainSelector from './controls/EffectChainSelector';
import makeVueControl from './utils/makeVueControl';

const EFFECT_CHAINS = {
  EXISTING_EFFECT_CHAIN: {
    title: '',
    label: 'Reuse existing effect chain',
    component: EffectChainSelector,
    options: {
      query: require('~lib/common/queries/EffectChain').fetch,
      queryProp: 'effectChains',
    },
  },
};

const EFFECT_CHAIN_CONTROLS = mapValues(EFFECT_CHAINS, effectChain => ({
  ...effectChain,
  control: makeVueControl(effectChain.component, effectChain.options),
}));

export default EFFECT_CHAIN_CONTROLS;
